import { LitEntity, css, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-surface';
import '../../common/bn-action';

class DeviceActions extends LitEntity {
  static get properties() {
    return {
      odooHref: { type: String, attribute: false },
      isInAnalysis: { type: Boolean, attribute: false },
      isInProductionDeviceTest: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: flex;
        flex-wrap: wrap;
      }
      bn-surface {
        min-width: calc(50% - 16px);
        box-sizing: border-box;
        flex-grow: 1;
        flex-shrink: 1;
      }
    `];
  }

  render() {
    const actions = ['update-bin', 'update-antenna'];
    if (this.isInAnalysis || this.isInProductionDeviceTest) {
      actions.push('update-firmware-mode');
    }
    return html`
      <lit-entity .href="${this.odooHref}" @update=${this._onUpdateOdoo}></lit-entity>
      ${actions.map(name => this.renderAction(name))}
    `;
  }

  renderAction(actionName) {
    return this.entity?.hasActionByName(actionName) ? html`
      <bn-surface>
        <bn-action .href="${this.href}" actionname="${actionName}"></bn-action>
      </bn-surface>
    ` : html``;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.odooHref = this.getHref('https://api.binsentry.com/rel/odoo-device-information');
  }

  _onUpdateOdoo(e) {
    const { properties } = e.detail?.entity || {};
    this.isInAnalysis = properties && (properties.location === undefined || properties.location.includes('BN-REFURB/Analysis'));
    this.isInProductionDeviceTest = properties?.location?.includes('Production Device Test');
  }
}

window.customElements.define('device-actions', DeviceActions);
